import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select";

// Connects to data-controller="purchase-order-shipments"
export default class extends Controller {
  static targets = ["purchaseOrderLineItem"]
  static values = {
    allOptions: Array
  }

  connect() {
  }

  toggleHiddenItems(event){
    const target = event.target.closest('.line_item').querySelector('.hidden-item')
    if(target){
      target.classList.toggle("hidden")
    }
  }

  purchaseOrderLineItemTargetConnected(element){
      const tomSelect = new TomSelect(element,{
        valueField: 'id',
        labelField: 'full_name',
        searchField: ['full_name', 'purchase_order', 'remaining_qty'],
        // fetch remote data
        render: {
          option: function(data, escape) {
            return `<div>
              <div class='text-xs'><span class='font-bold text-blue-600'>[${escape(data.purchase_order)}]</span> ${escape(data.full_name)} <span class='font-medium text-orange-600'>(${escape(data.remaining_qty)})</span></div>
            </div>`;
          },
          item: function(data, escape) {
            return `<div>
              <div class='text-xs'><span class='font-bold text-blue-600'>[${escape(data.purchase_order)}]</span> ${escape(data.full_name)} <span class='font-medium text-orange-600'>(${escape(data.remaining_qty)})</span></div>
            </div>`;
          }
        }
      })

      this.selectedPurchaseOrderItems(element).forEach(element => {
        tomSelect.removeOption(element.id)
      })

      const blurHandler = () => {
        tomSelect.close();
        tomSelect.blur();
      };

      element._tomSelectBlurHandler = blurHandler;
      window.addEventListener('blur', blurHandler);
  }

  purchaseOrderLineItemTargetDisconnected(element) {
    console.log("Target disconnected, removing its blur listener and destroying TomSelect.");

    // 1. Find the specific handler we stored on the element.
    const blurHandler = element._tomSelectBlurHandler;

    // 2. If it exists, remove it from the window.
    if (blurHandler) {
      window.removeEventListener('blur', blurHandler);
    }

    // 3. Properly destroy the TomSelect instance associated with this element.
    if (element.tomselect) {
      element.tomselect.destroy();
    }
  }

  removePurchaseOrderSelection(event){
    const select = event.target.closest('.line_item').querySelector('.tomselected')
    const tomselect = select.tomselect
    this.purchaseOrderLineItemTargets.forEach(element => {
      if(tomselect != element.tomselect){
        element.tomselect.addOption(tomselect.options[select.value])
      }
    });
    select.value = null
  }

  updatePurchaseOrderSelection(event){
    const currentValue = event.target.value

    if (currentValue){
      this.purchaseOrderLineItemTargets.forEach(element => {
        if(event.target.tomselect != element.tomselect){
          element.tomselect.removeOption(currentValue)
        }
      });
    }

    if(event.target.dataset.testValue != event.target.value){
      event.target.dataset.previousValue = event.target.dataset.testValue
      event.target.dataset.testValue = event.target.value
    }

    if(event.target.dataset.previousValue && event.target.dataset.previousValue != 'undefined' && event.target.tomselect.options[event.target.dataset.previousValue]){
      this.purchaseOrderLineItemTargets.forEach(element => {
        if(event.target.tomselect != element.tomselect){
          element.tomselect.addOption(event.target.tomselect.options[event.target.dataset.previousValue])
        }
      });
    }

  }

  selectedPurchaseOrderItems(tomselect_ele){
    let items = []
    this.purchaseOrderLineItemTargets.forEach(element => {
      if(tomselect_ele != element){
        if(element.tomselect && element.value){
          items.push(element.tomselect.options[element.value])
        }
      }
    });
    return items
  }

}
